import React, { FunctionComponent } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Button, { ButtonProps } from './Button';

export interface ButtonsProps extends FlexProps<'div'> {
  ctas?: ButtonProps[];
}

const Buttons: FunctionComponent<ButtonsProps> = (props) => {
  const { ctas = [], ...flexProps } = props;
  const { spacing } = useTheme();

  if (ctas?.length === 0) {
    return null;
  }
  return (
    <Flex width="100%" maxWidth={spacing(75)} flexDirection="column" alignItems="stretch" {...flexProps}>
      {ctas.map((ctaProps, index) => {
        return <Button key={index} css={{ display: 'inline-flex', margin: spacing(2, 0) }} {...ctaProps} />;
      })}
    </Flex>
  );
};

export default Buttons;
